import styles from './Elevator.module.css'

const Elevator = (props: { children: React.ReactNode }) => {
  return (
    <div className={styles.container}>
      {props.children}
    </div>
  )
}

export default Elevator